import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, 
  faInfoCircle, 
  faChevronDown,
  faChartLine,
  faClock,
  faCoins,
  faArrowUp,
  faArrowDown
} from '@fortawesome/free-solid-svg-icons';
  import { FaBitcoin } from 'react-icons/fa';

const BitcoinMarketStats = () => {
  const [timeframe, setTimeframe] = useState('24h');
  const [isStarred, setIsStarred] = useState(false);

  return (
    <div className="portfolio-card-modern rounded-4 shadow-sm p-4 mb-4"
      style={{
        background: "linear-gradient(90deg, #18181b 0%, #17171885 100%)",
        border: "1px solid #23272f",
        color: "#fff",
      }}>
      
      {/* Header */}
      <div className="row align-items-center justify-content-between mb-4 g-3">
        <div className="col-md-auto">
          <h6 className="fw-semibold mb-1 text-white">Market stats</h6>
          <small className="text-secondary">
            Bitcoin Market Overview
          </small>
        </div>
      </div>

      {/* Main Content */}
      <div className="row align-items-center">
        {/* Left Side - Bitcoin Info */}
        <div className="col-md-4">
          <div className="d-flex align-items-start flex-wrap">
            <div>
              <div className="text-secondary small mb-1 d-flex align-items-center">
                <div
                  className="balance-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                  style={{
                    background: "#f7931a",
                    width: "30px",
                    height: "30px",
                    boxShadow: "0 2px 8px 0 rgba(247,147,26,0.12)",
                  }}
                >
                  <FaBitcoin style={{ fontSize: "15px", color: "#fff" }} />
                </div>
                <span>Bitcoin (BTC)</span>
              </div>
              <div className="gap-4 d-flex align-items-center justify-content-between">
                <div className="fs-4 fw-bold text-white">
                  Bitcoin
                </div>
                <button 
                  className={`btn btn-outline-secondary bg-black border-0 btn-sm rounded-3 ${isStarred ? 'text-warning' : ''}`}
                  style={{ fontSize: "13px" }}
                  onClick={() => setIsStarred(!isStarred)}
                >
                  <FontAwesomeIcon
                    icon={faStar}
                    className="ms-2"
                    style={{
                      fontSize: "10px",
                      cursor: "pointer",
                      color: isStarred ? "#fbbf24" : "#94a3b8",
                    }}                
                  />
                </button>
              </div>
              <div className="mt-2 d-flex" style={{fontSize:'10px'}}>
                <span className="text-secondary small me-2">Rank #1</span>
                <span className="text-secondary small me-2">Coin</span>
                <span className="text-secondary small me-2">On 2,771,773 watchlists</span>              
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Price and Chart (Image Layout) */}
        <div className="col-md-8">
          <div className="price-section">
            <div className="text-secondary small mb-3 d-flex align-items-center">
              <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
              Bitcoin Price(USD)
            </div>
            
            <div className="d-flex align-items-center mb-4">
              <h4 className="fw-bold text-white me-3" style={{ fontSize: "1.5rem", margin: 0 }}>
                $43,975.72
              </h4>
              <span className="text-success fw-semibold">
                +2% <FontAwesomeIcon icon={faArrowUp} />
              </span>
            </div>
            
            <div className="price-range-section">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="text-secondary small">High / Low Price</span>
                <div className="btn btn-outline-secondary bg-black border-0 btn-sm rounded-3" style={{ fontSize: "13px" }}>
                  {timeframe} <FontAwesomeIcon icon={faChevronDown} className="ms-1" />
                </div>
              </div>
              
              <div className="range-bar mb-2" style={{
                position: "relative",
                height: "4px",
                background: "#2d3748",
                borderRadius: "2px",
                margin: "1rem 0"
              }}>
                <div style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: "75%",
                  background: "linear-gradient(90deg, #3b82f6 0%, #ffffff 100%)",
                  borderRadius: "2px"
                }}></div>
                <div style={{
                  position: "absolute",
                  top: "-2px",
                  right: "25%",
                  width: "8px",
                  height: "8px",
                  background: "#ffffff",
                  borderRadius: "50%"
                }}></div>
              </div>
              
              <div className="d-flex justify-content-between">
                <span className="text-secondary small">Low : $37,005.19</span>
                <span className="text-secondary small">High : $37,005.19</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Stats Cards */}
      <div className="row mt-4 g-3">
        <div className="col-lg-3 col-md-6">
          <div className="portfolio-metric-card px-3 py-2 text-center h-100">
            <div className="text-secondary small mb-3 d-flex align-items-center justify-content-start gap-1">
              <FontAwesomeIcon icon={faChartLine} /> Market Cap
            </div>
            <div className="fw-semibold text-white text-start">
              $826,445,951,378
            </div>
            <div className="text-success text-start fw-semibold small">
              +2% <FontAwesomeIcon icon={faArrowUp} />
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div className="portfolio-metric-card px-3 py-2 text-center h-100">
            <div className="text-secondary small mb-3 d-flex align-items-center justify-content-start gap-1">
              <FontAwesomeIcon icon={faInfoCircle} /> Full Diluted
            </div>
            <div className="fw-semibold text-white text-start">
              $915,435,574,336
            </div>
            <div className="text-danger text-start fw-semibold small">
              -28% <FontAwesomeIcon icon={faArrowDown} />
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div className="portfolio-metric-card px-3 py-2 text-center h-100">
            <div className="text-secondary small mb-3 d-flex align-items-center justify-content-start gap-1">
              <FontAwesomeIcon icon={faClock} /> 24 Volume
            </div>
            <div className="fw-semibold text-white text-start">
              $22,822,762,169
            </div>
            <div className="text-success text-start fw-semibold small">
              +2% <FontAwesomeIcon icon={faArrowUp} />
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div className="portfolio-metric-card px-3 py-2 text-center h-100">
            <div className="text-secondary small mb-3 d-flex align-items-center justify-content-start gap-1">
              <FontAwesomeIcon icon={faInfoCircle} /> Circulating Supply
            </div>
            <div className="fw-semibold text-white text-start">
              18,958,437.00 BTC
            </div>
            <div className="text-start text-secondary small">
              Max supply 21,000,000
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BitcoinMarketStats; 